<template>
  <div class="tooltip-container flex">
    <div class="tooltip-content" v-html="content"></div>
    <span class="iconfont iconx" @click="handleClose"></span>
    <div class="triangle" :class="triangleClass"></div>
  </div>
</template>

<script>
	export default {
		name: 'w-tooltip',
		props: {
			content: {
				type: String,
				default: '您可以在这里选择历史经历，点击试试'
			},
			// 三角形的的class
			triangleClass: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/global/variable';
  .tooltip-container {
    position: relative;
    padding: 12px 18px;
    width: 200px;
    background-color: $color-title;
    border-radius: 6px;
    color: $color-light;
    .tooltip-content {
      margin-right: 10px;
      line-height: 20px;
    }
    .iconfont {
      color: $color-light;
    }
    .triangle {
      position: absolute;
      bottom: -20px;
      left: 95px;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-top: 10px solid #404040;
    }
  }
</style>
